import axios from 'axios'
import router from '../router/index'

// 设置失败后重新请求次数
axios.defaults.retry = 1
// 设置请求间隔
axios.defaults.retryDelay = 2000

// 拦截器
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  if (err.response.status == 401) {
    router.push('/p/login')
    return Promise.reject(err)
  }
  var config = err.config;
  // 如果不存在retry参数选项，直接reject
  if(!config || !config.retry) return Promise.reject(err);

  // 设置变量以跟踪重试计数
  config.__retryCount = config.__retryCount || 0;

  // 检查我们是否已经最大化了重试次数
  if(config.__retryCount >= config.retry) {
    // 如果两次请求后仍然是401，说明用户过期，跳转到登录页，重新登陆
    return Promise.reject(err);
  }

  // 递增 retry count
  config.__retryCount += 1;

  // 创建处理指数返回的新promise
  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, config.retryDelay || 1);
  });

  // 返回召回axios的promise，以重试请求
  return backoff.then(function() {
    return axios(config);
  });
});

export default class APIS {
  /**
   * 登陆
   * @param {*} params: {WxId, user_name, passwd}
   */
  static LOGIN (params) {
    return axios.post('/api/frontend/login', params).then((res) => res).catch((err) => err)
  }

  static DAN_DIAN_LOGIN (params) {
    return axios.post('/api/frontend/login', params).then(res => res).catch(err => err)
  }

  /**
   * 登出
   */
  static LOGOUT () {
    return axios.get('/api/frontend/logout').then((res) => res).catch((err) => err)
  }

  /**
   * 请求订单数据
   * @param {*} params: {user_id, cmd}
   */
  static REQUEST_ORDERS (params) {
    return axios.post('/api/frontend/day_order', params).then((res) => res).catch((err) => err)
  }

  /**
   * 请求菜金数据
   * @param {*} id 用户ID
   */
  static REQUEST_MEAL_MONEY (id) {
    return axios.get('/api/frontend/daily_price?user_id=' + id).then((res) => res).catch((err) => err)
  }

  /**
   * 请求评价信息
   * @param {*} params：{page_now, user_id}
   */
  static REQUEST_COMMENTS (params) {
    return axios.get('/api/frontend/discuss_data?page_now=' + params.page_now + '&user_id=' + params.user_id).then((res) => res).catch((err) => err)
  }

  /**
   * 推荐商家
   * @param {*} params: {formData}
   */
  static RECOMMEND_SHOP (params) {
    return axios.post('/api/frontend/busi_recommend/recommend', params).then((res) => res).catch((err) => err)
  }

  /**
   * 修改密码
   * @param {*} params: {flag, new_password, old_password, user_id}
   */
  static MODIFY_PASSWORD (params) {
    return axios.post('/api/frontend/user_manage', params).then((res) => res).catch((err) => err)
  }

  /**
   * 获取今日排单商家
   * @param {*} params
   */
  static REQUEST_WORK_SHOPS (params) {
    return axios.post('/api/frontend/select_order', params).then((res) => res).catch((err) => err)
  }

  /**
   * 获取商家详细商品信息
   * @param {*} params
   */
  static REQUEST_WORK_SHOP_DETAIL (params) {
    return axios.post('/api/frontend/select_order', params).then((res) => res).catch((err) => err)
  }

  /**
   * 获取单个商品的评论信息
   * @param {*} params
   */
  static REQUEST_MEAL_COMMENTS (params) {
    return axios.post('/api/frontend/discuss_data', params).then((res) => res).catch((err) => err)
  }

  /**
   * 提交订单
   * @param {*} params
   */
  static SUBMIT_ORDERS (params) {
    return axios.post('/api/frontend/order', params).then((res) => res).catch((err) => err)
  }

  /**
   * 修改头像
   * @param {*} params
   */
  static MODIFY_AVATAR (params) {
    return axios.post('/api/frontend/user_manage', params).then((res) => res).catch((err) => err)
  }

  /**
   * 撤销订单
   * @param {*} params
   */
  static CANCEL_ORDERS (params) {
    return axios.post('/api/frontend/cancel_order', params).then((res) => res).catch((err) => err)
  }

  /**
   * 日常菜品评论
   * @param {*} params
   */
  static ORDER_COMMENT (params) {
    return axios.post('/api/frontend/daily_discuss', params).then((res) => res).catch((err) => err)
  }

  /**
   * 试吃评论
   * @param {*} params
   */
  static TRY_EAT_ORDER_COMMENT (params) {
    return axios.post('/api/frontend/try_discuss', params).then((res) => res).catch((err) => err)
  }

  /**
   * 菜金纠错
  */
  static CORRECT_MENU_MONEY (params) {
    return axios.post('/api/frontend/emp_money_check/correct_menu_money', params).then(res => res).catch(err => err)
  }

  /**
   * 获取是否需要菜金确认
  */
  static GET_MONEY_CONFIRM () {
    return axios.get('/api/frontend/emp_money_check').then(res => res).catch(err => err)
  }

  /**
   * 确认菜金
  */
  static CONFIRM_MONEY () {
    return axios.post('/api/frontend/emp_money_check/check_menu_money').then(res => res).catch(err => err)
  }
}



// WEBPACK FOOTER //
// ./src/apis/index.js